import React, { useEffect, useState } from 'react';

import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { Route, Redirect, useLocation } from 'react-router-dom';

// eslint-disable-next-line import/extensions
import CookiesInfo from 'components/CookiesInfo/CookiesInfo.tsx';
import hashLinkScroll from 'helpers/hashLinkScroll';
import { useAuthContext } from 'reactContext/AuthContext';
import PATHS from 'router/PATHS';

const COOKIE_NAME = 'cookie_consent';

const PublicRoute = ({ redirectIfAuthorized, ...rest }) => {
  const authContext = useAuthContext();
  const { state } = useLocation();

  const [hideCookiesInfo, setHideCookiesInfo] = useState(Cookies.get(COOKIE_NAME));

  const hideCookies = () => {
    setHideCookiesInfo(true);
    Cookies.set(COOKIE_NAME, true);
  };

  useEffect(() => {
    hashLinkScroll();
  }, []);

  if (authContext.isAuthorized && redirectIfAuthorized) return <Redirect to={{ pathname: state?.redirectedFrom || PATHS.ROOT }} />;
  return (
    <>
      <Route {...rest} />
      {!hideCookiesInfo && <CookiesInfo onClose={hideCookies} />}
    </>
  );
};

PublicRoute.propTypes = {
  redirectIfAuthorized: PropTypes.bool.isRequired,
};

export default PublicRoute;
